<template>
  <main class="min-h-screen bg-gray-200">
    <header class="">
      <div class="border-b border-gray-300">
        <div
          class="max-w-2xl lg:border-r border-gray-300 px-4 py-4 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8"
        >
          <div class="flex-1 min-w-0">
            <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
              {{ $t('issuers_title') }}
            </h1>
          </div>
          <div class="mt-4 flex sm:mt-0 sm:ml-4">
            <span class="order-1 ml-3 shadow-sm rounded-md sm:order-0 sm:ml-0">
              <router-link :to="{ name: 'issuer-add' }">
                <sqr-button :label="$t('issuers_add')" color="green">
                  <template slot="icon">
                    <PlusIcon class="inline w-4 h-4 stroke-current" />
                  </template>
                </sqr-button>
              </router-link>
            </span>
          </div>
        </div>
      </div>
      <sqr-progress v-show="loading" />
      <sqr-error-banner :error="loadError" />
    </header>

    <div v-show="issuers.length > 0" class="md:p-4 max-w-2xl">
      <div class="bg-white shadow  md:rounded-md">
        <ul>
          <li
            v-for="(issuer, index) in issuers"
            :key="issuer.id"
            :class="{ 'border-t border-gray-200': index > 0 }"
          >
            <router-link
              :to="{ name: 'issuer-edit', params: { aid, id: issuer.id } }"
              class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <div
                    class="text-sm leading-5 font-medium text-blue-600 truncate"
                  >
                    <div class="mb-1">
                      {{ issuer | practice }}
                    </div>
                    <div class="sm:flex">
                      <div
                        class="mr-6 flex items-center text-sm leading-5 text-gray-500"
                      >
                        <HashtagIcon
                          class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                        />
                        {{ issuer.rccNumber }}
                      </div>
                      <div
                        class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mt-0"
                      >
                        <LocationMarkerIcon
                          class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                        />
                        {{ issuer.addressLocality }}
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-between space-x-4">
                    {{ issuer.telephone }}
                  </div>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  HashtagIcon,
  LocationMarkerIcon,
  PlusIcon
} from '@vue-hero-icons/outline';
import SqrProgress from '@/components/SqrProgress';
import SqrErrorBanner from '@/components/SqrErrorBanner';
import SqrButton from '@/components/SqrButton';
import practice from '@/filters/practice';

export default {
  name: 'Issuers',
  components: {
    SqrProgress,
    SqrErrorBanner,
    SqrButton,
    HashtagIcon,
    LocationMarkerIcon,
    PlusIcon
  },
  filters: { practice },
  props: { aid: String },
  computed: {
    ...mapGetters('account', ['issuers', 'loading', 'loadError'])
  },
  mounted() {
    this.$a().logEvent('issuers');
  }
};
</script>
